import React from 'react';
import yogaImage1 from './assets/yoga_side.jpg';
import './About.css';

const About = () => {
  return (
    <div className="about-background">
      <div className="about-container">
        <img
          src={yogaImage1}
          alt="Yoga"
          className="img-fluid rounded float-end ms-3 mb-3"
          style={{ maxWidth: '300px' }}
        />

        <h1>About Eliza Cikoratic</h1>
        <p>
          Eliza is a highly experienced and internationally trained yoga and 
          pilates teacher with over a decade of personal practise and teaching, 
          and more than 1,300 hours of formal teacher training across vinyasa, hatha, 
          ashtanga, yin, tantra, aerial and paddle yoga.
          She is also a qualified mat and reformer pilates instructor.
        </p>
        <p>
          In addition to her movement expertise, Eliza is both a certified Tantric 
          facilitator and Wilka Suyu cacao ceremonialist, integrating sacred embodiment, 
          ritual, and heart-centred presence to her offerings. Her work weaves together ancient
          traditions and modern somatic, creating spaces that honour the physical, spiritual, and
          emotional dimensions of healing and growth.
        </p>
        <p>
          She has taught at renowned studios across Australia, luxury resorts in Bali and the Maldives,
          and led immersive workshops and ceremonies around the world. In 2023, she was honoured to be 
          a guest facilitator for meditation and breath work at the Forbes Women’s Summit in Saudi Arabia,
          sharing her teachings with a global audience.
        </p>
        <p>
          Whether guiding a soulful yoga practise, leading ceremony, or space for transformation, 
          Eliza's work is rooted in devotion to presence, consciousness embodiment, and joyful living.   
        </p>
      </div>
    </div>
  );
};

export default About;
